import { Component, OnDestroy, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { Product } from '../_models/product';
import { ProductType } from '../_models/product_type';
import { MessService } from '../_services/mess-service.service';
import { ProductTypesService } from '../_services/product-types.service';
import { ProductsService } from '../_services/products.service';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss'],
})
export class ProductsComponent implements OnInit, OnDestroy {
  loading: boolean = true;

  products: Product[];

  productTypes: ProductType[];

  subscriptions: Subscription[] = [];

  constructor(
    private confirmationService: ConfirmationService,
    private messService: MessService,
    private productsService: ProductsService,
    private productTypesService: ProductTypesService
  ) {}

  // * Lifecycles === //
  ngOnInit(): void {
    this.updateProductList();

    this.subscriptions.push(
      this.productTypesService
        .getAllProductTypes()
        .subscribe((productTypes) => {
          this.productTypes = productTypes;
          this.loading = false;
        })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  // * Helpers === //
  onEditProduct(productData: Product) {
    this.productsService.updateProductData.next(productData);
  }

  onCopyProduct(productData: Product) {
    this.productsService.copyProductData.next(productData);
  }

  private updateProductList() {
    this.loading = true;
    this.subscriptions.push(
      this.productsService.getAllProducts().subscribe((products) => {
        this.products = products;
        this.loading = false;
      })
    );
  }

  // * Delete product === //
  onDeleteProduct(productId: number) {
    this.confirmationService.confirm({
      target: event.target,
      message: 'Da li ste sigurni da želite da obrišete proizvod?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.subscriptions.push(
          this.productsService.deleteProduct(productId).subscribe(
            () => {
              this.messService.add({
                severity: 'success',
                title: 'Uspešno brisanje',
                detail: 'Uspešno ste obrisali proizvod!',
              });
              this.updateProductList();
            },
            (error) => {
              this.messService.add({
                severity: 'error',
                title: 'Greška',
                detail: 'Došlo je do greške, pokušajte ponovo!',
              });
            }
          )
        );
      },
    });
  }
}
